import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NavigationHistoryService {
  private routeStack: string[] = [];
  private maxHistorySize = 50; // Limiter la taille de l'historique
  
  constructor(private router: Router) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        if (event instanceof NavigationEnd) {
          this.addToHistory(event.urlAfterRedirects);
        }
      });
  }
  
  private addToHistory(url: string) {
    // Éviter les doublons consécutifs
    if (this.routeStack.length === 0 || this.routeStack[this.routeStack.length - 1] !== url) {
      this.routeStack.push(url);
      
      // Limiter la taille de l'historique
      if (this.routeStack.length > this.maxHistorySize) {
        this.routeStack.shift();
      }
    }
  }
  
  getRouteStack(): string[] {
    return [...this.routeStack];
  }
  
  getPreviousRoute(): string | null {
    return this.routeStack.length > 1 
      ? this.routeStack[this.routeStack.length - 2] 
      : null;
  }
  
  getCurrentRoute(): string | null {
    return this.routeStack.length > 0 
      ? this.routeStack[this.routeStack.length - 1] 
      : null;
  }
  
  getRouteStackLength(): number {
    return this.routeStack.length;
  }
  
  clearHistory() {
    this.routeStack = [];
  }
  
  // Vérifier si une route existe dans l'historique
  hasRouteInHistory(route: string): boolean {
    return this.routeStack.includes(route);
  }
  
  // Obtenir l'index d'une route dans l'historique
  getRouteIndex(route: string): number {
    return this.routeStack.indexOf(route);
  }
} 